import { FunctionComponent, useState } from 'react';
import DashboardLayout from '../../../components/layout/layout';
import SearchInventoryIcon from '../../../assets/img/inventory_black.png';
import { Paper, Box, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Skeleton, Typography } from '@mui/material';
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate, Link } from 'react-router-dom';
import RecentInventorySearch, { InventoryProps } from '../../../components/common/recent-inventory-search';
import { useGetInventory } from '../../../hooks/api/user';
import moment from "moment";
import StorageService from '../../../services/storageService';

const TableCol = styled(TableCell)(({ theme }) => ({
  border: '1px solid rgba(224, 224, 224, 1)',
}));

const LeadTimeSearchResultWhoHasIt: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const partNumber = queryParams.get('partNo') || '';
  const { data: inventory = [], error, isFetched: hasFetched, isLoading } = useGetInventory({ partNo: partNumber, exactSearch: true });
  StorageService.setRecentSearchPartNumber(partNumber.trim());

  const isErrorObject = inventory && !Array.isArray(inventory);
 //const inventoryData: InventoryProps[] = Array.isArray(inventory) ? inventory : [];
  const inventoryData: InventoryProps[] = Array.isArray(inventory?.data) ? inventory.data : [];

  return (
    <>
      <DashboardLayout titleIcon={<img src={SearchInventoryIcon} alt="Search Inventory" style={{ width: 25, height: 25 }} />} title={"Inventory"} initialBreadcrumbs={"Channel Partners/ Inventory"} levelBreadcrumbs={''} breadcrumbs={' List Price Lead Time Search'} activeMenu={'inventory'}>
        <Box sx={{ width: '100%', maxWidth: '100%'}}>
          <TableContainer component={Paper} variant="outlined" sx={{ maxWidth: "100%", overflowX: "auto", borderRadius: 0, mt: 1 }}>
            <Table size="small" aria-label="inventory list table">
              <TableHead sx={{ backgroundColor: "#c3183c" }}>
                <TableRow>
                  <TableCell colSpan={5} sx={{ color: 'white' }}>
                    Barksdale Part Number: {partNumber}
                  </TableCell>
                </TableRow>
              </TableHead>
                
              <TableHead sx={{ backgroundColor: "#f2f2f2" }}>
                <TableRow>
                
                  <TableCol>Date</TableCol>
                  <TableCol>In Stock</TableCol>
                  <TableCol>Company</TableCol>
                  <TableCol>Details</TableCol>
                </TableRow>
              </TableHead>
                
              <TableBody>
                {
                  isLoading?(
                  <TableRow>
                    <TableCol colSpan={5}>
                      <Skeleton width="38%" />
                      <Skeleton width="100%" />
                      <Skeleton width="100%" />
                      <Skeleton width="61%" />
                    </TableCol>
                  </TableRow>
                ):hasFetched && inventoryData.length === 0 ? (
                   //</Table> inventory.length === 0 ?
                      <TableRow>
                        <TableCol colSpan={5} sx={{ textAlign: 'center' }}>
                          <Typography variant="body1" color="text.secondary">
                            {isErrorObject ? inventory.message : "No Data Found"}
                          </Typography>
                    
                        </TableCol>
                      </TableRow>
                    ):( 
                      inventoryData.map((inventory: InventoryProps, idx: number) => (
                        <TableRow key={idx + 1} hover>
                          
                          <TableCol>{moment(inventory.freshDate).format('MM/DD/YYYY')}</TableCol>
                          <TableCol>{inventory.qty}</TableCol>
                          <TableCol>{inventory.repName}</TableCol>
                          <TableCol>
                            <Link
                              to={`/inventory/details/${inventory.repName}/${inventory.partNo}`}
                              color="#c3183c"
                              style={{
                                textDecoration: "underline",
                                color: "#c3183c",
                                cursor: "pointer",
                              }}
                            >See Details</Link>
                          </TableCol>
                        </TableRow>
                      ))
                  ) 
                }
              </TableBody> 
            </Table>
          </TableContainer>  
          <Box sx={{ mt: 3, textAlign: 'right' }}>
            <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important' }} onClick={() => navigate(-1)}>
              BACK
            </Button>
          </Box>
      </Box>

        {/* <RecentInventorySearch /> */}
    </DashboardLayout>
    </>
  )
};

export default LeadTimeSearchResultWhoHasIt;